import React from "react";
import getWidgetComponentFactory from "./getWidgetComponent";

const Widget = (widgetsMap) => {
  const getWidgetComponent = getWidgetComponentFactory(widgetsMap);
  return ({ data, ...attributes }) => {
    const Component = getWidgetComponent(attributes.type);

    return <Component attributes={attributes} data={data.data} />;
  };
};

export default Widget;
